module.exports = __webpack_public_path__ + "static/media/Location.svg";